import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/global.d.ts').Banner}
 */
const Banner = ({
    heading = null,
    text = null
}) => {
    if (!heading && !text) {
        return null;
    }

    return (
        <section className='layout-container bg-neutral-00'>
            <div className='pt-16 sm:pt-32 pb-32 sm:pb-100'>
                <div className='sm:layout-grid flex flex-col sm:flex-row gap-y-16'>
                    <div className='sm:w-4/12 lg:w-3/12 sm:layout-grid-col'>
                        {heading && (
                            <h2 className='type-style-heading'>{heading}</h2>
                        )}
                    </div>

                    <div className='sm:w-8/12 sm:layout-grid-col'>
                        <div className='layout-grid'>
                            {text && (
                                <div
                                    className='w-full sm:w-6/8 layout-grid-col rich-text type-style-heading'
                                    dangerouslySetInnerHTML={{ __html: text }} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Banner;
